import { WebSocketMessageTypeIncoming } from '../../../Enums/WebSocketMessageTypeIncoming';
import { SettingsWebPortal } from '../../Settings/SettingsWebportal';

export class WsRefreshWebPortalSetting {
  public Type!: WebSocketMessageTypeIncoming;
  public SettingWebportal!: SettingsWebPortal;
  public SessionInBrowserId!: string;

  constructor() {
    this.Type = WebSocketMessageTypeIncoming.WsRefreshWebPortalSetting;
  }
}
